// frontend/src/services/subscriptionService.ts
/**
 * Service for subscription-related API calls
 */
import { apiRequest, apiPost, apiGet } from '../auth';
import type {
    SubscriptionStatusResponse,
    UsageStats,
    CheckoutSessionResponse,
    PaymentHistory,
    SubscriptionTier,
    BillingPeriod
} from '../types/subscription';

const BASE_URL = '/api/subscriptions';

/**
 * Create a Stripe checkout session for subscription purchase
 */
export async function createCheckoutSession(
    tier: SubscriptionTier,
    billingPeriod: BillingPeriod = BillingPeriod.ANNUAL
): Promise<CheckoutSessionResponse> {
    return apiPost<CheckoutSessionResponse>(`${BASE_URL}/create-checkout-session`, {
        tier,
        billing_period: billingPeriod,
    });
}

/**
 * Get current user's subscription status and usage
 */
export async function getSubscriptionStatus(): Promise<SubscriptionStatusResponse> {
    return apiGet<SubscriptionStatusResponse>(`${BASE_URL}/status`);
}

/**
 * Get current user's usage statistics
 */
export async function getUsageStats(): Promise<UsageStats> {
    return apiGet<UsageStats>(`${BASE_URL}/usage`);
}

/**
 * Cancel current user's subscription
 */
export async function cancelSubscription(immediate: boolean = false): Promise<{ message: string }> {
    return apiRequest<{ message: string }>(`${BASE_URL}/cancel`, {
        method: 'POST',
        body: JSON.stringify({ immediate }),
    });
}

/**
 * Get payment history for current user
 */
export async function getPaymentHistory(limit: number = 10): Promise<PaymentHistory[]> {
    return apiGet<PaymentHistory[]>(`${BASE_URL}/payment-history?limit=${limit}`);
}
